import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RxSelectBoxItemObject } from "../../components/RxSelectBox/RxSelectBox";
import RxStepForm from "../../components/RxStepForm";
import api from "../../config/AxiosConfig";
import { addNotification } from "../../redux/slices/notification-slice";
import { store } from "../../redux/store";
import LoginInfoStep from "./LoginInfoStep";
import {
	RegisterObject,
	RegisterObjectInitialValue,
	SavedUserResponseDTO,
} from "./RegisterObject";
import styles from "./RegisterPage.module.css";
import UserInfoStep from "./UserInfoStep";

export interface UserStepFormValidationObject {
	values: RegisterObject;
	isLoginInfoStepValid: boolean;
	isUserInfoStepValid: boolean;
}

const RegisterPage = () => {
	const history = useHistory();
	const isUserLoggedIn = useSelector((state: any) => state.user.userLoggedIn);
	const [googleReCaptchaToken, setGoogleReCaptchaToken] = useState<string>();
	const [selectConstantDataList, setSelectConstantDataList] = useState<{
		provinces: RxSelectBoxItemObject[];
		companyTypes: RxSelectBoxItemObject[];
		jobTypes: RxSelectBoxItemObject[];
	}>({ provinces: [], companyTypes: [], jobTypes: [] });

	const [userValidationObject, setUserValidationObject] =
		useState<UserStepFormValidationObject>({
			values: RegisterObjectInitialValue,
			isLoginInfoStepValid: false,
			isUserInfoStepValid: false,
		});

	const registerUser = async () => {
		if (googleReCaptchaToken !== undefined) {
			await api
				.post("/1/users", {
					email: userValidationObject.values.loginInfo.email,
					password: userValidationObject.values.loginInfo.password,
					firstname: userValidationObject.values.userInfo.name,
					lastname: userValidationObject.values.userInfo.surname,
					job: userValidationObject.values.userInfo.job,
					title: userValidationObject.values.userInfo.title,
					phone: userValidationObject.values.userInfo.phone,
					gsm: userValidationObject.values.userInfo.gsm,
					companyType: userValidationObject.values.userInfo.companyType,
					companyName: userValidationObject.values.userInfo.companyName,
					province: userValidationObject.values.userInfo.province,
					district: userValidationObject.values.userInfo.district,
					address: userValidationObject.values.userInfo.address,
					recaptchaToken: googleReCaptchaToken,
				})
				.then((data: SavedUserResponseDTO) => {
					store.dispatch(
						addNotification({
							message:
								"Başarılı bir şekilde kaydedildi. Lütfen giriş yapınız.",
							type: "success",
						})
					);
					history.push("/");
				});
		}
	};

	const getConstantDataList = async () => {
		const jobTypes: RxSelectBoxItemObject[] = await api.get("/1/job-types");
		const provinces: RxSelectBoxItemObject[] = await api.get("/1/provinces");
		const companyTypes: RxSelectBoxItemObject[] = await api.get(
			"/1/company-types"
		);

		setSelectConstantDataList({
			companyTypes: companyTypes,
			provinces: provinces,
			jobTypes: jobTypes,
		});
	};

	useEffect(() => {
		if (isUserLoggedIn) {
			history.push("/");
		}
	}, [isUserLoggedIn]); // eslint-disable-line

	useEffect(() => {
		getConstantDataList();
	}, []);

	useEffect(() => {
		registerUser();
	}, [googleReCaptchaToken]); // eslint-disable-line

	return (
		<RxStepForm
			title="Kayıt"
			width="50%"
			minWidth="900px"
			className={styles.mainContainer}
			steps={[
				{
					title: "Giriş Bilgileri",
					content: (
						<LoginInfoStep
							setValidataResult={setUserValidationObject}
							values={userValidationObject.values}
						/>
					),
					valid: userValidationObject.isLoginInfoStepValid,
				},
				{
					title: "Kullanıcı Bilgileri",
					content: (
						<UserInfoStep
							setValidataResult={setUserValidationObject}
							values={userValidationObject.values}
							constantDataList={selectConstantDataList}
							setGoogleReCaptchaToken={setGoogleReCaptchaToken}
						/>
					),
					valid: userValidationObject.isUserInfoStepValid,
					nextButtonName: "Kaydol",
					nextButtonColor: "secondary",
					nextButtonId: "submit",
					nextButtonOnClick: registerUser,
				},
			]}
		/>
	);
};

export default RegisterPage;
